import CryptoJS from 'crypto-js'

export const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition((pos, err) => {
            if (pos) {
                return resolve(pos.coords)
            } else {
                return reject(err)
            }
        });
    })
}

export const getBase64Url = (file) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    var base64 = new Promise(function(resolve, reject) {
        reader.onload = (event) => {
            if (event.target)
                resolve(event.target.result);
            else
                reject(new Error('fail'))
        };
    });
    return base64;
}

export const parsoDi = data => {
    if (typeof data === "string") {
        return CryptoJS.AES.encrypt(data, 'karnhwa gang').toString()
    }
    return CryptoJS.AES.encrypt(JSON.stringify(data), 'karnhwa gang').toString()
}

export const narsoDi = data => {
    if (typeof data === "string") {
        let bytes = CryptoJS.AES.decrypt(data.toString(), 'karnhwa gang')
        return bytes.toString(CryptoJS.enc.Utf8);
    }
    return CryptoJS.AES.decrypt(JSON.stringify(data), 'karnhwa gang').toString()
}

// export const capturePhoto = (_this, obj) => {
//     _this.video = document.getElementById('video');
//     _this.canvas = document.getElementById('canvas');
//     _this.photo = document.getElementById('photo');
//     _this.startbutton = document.getElementById('startbutton');
//     navigator.mediaDevices.getUserMedia(obj)
//         .then((stream) => {
//             video.srcObject = stream;
//             video && video.play();
//             _this.runStream = stream
//             _this.istakePhoto = true
//         })
//         .catch(function(err) {
//             console.log("An error occurred: " + err);
//         });
//     _this.video.addEventListener('canplay', (ev) => {
//         if (!_this.streaming) {
//             _this.height = _this.video.videoHeight / (_this.video.videoWidth / _this.width);
//             if (isNaN(_this.height)) {
//                 _this.height = _this.width / (4 / 3);
//             }
//             _this.video.setAttribute('width', _this.width);
//             _this.video.setAttribute('height', _this.height);
//             _this.canvas.setAttribute('width', _this.width);
//             _this.canvas.setAttribute('height', _this.height);
//             _this.streaming = true;
//             _this.showPicture = false
//         }
//     }, false);
// }


export const base64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
}
export const toaster = (_this, msg, position, duration) => {
    _this.$toasted.show(msg, {
        theme: "outline",
        duration: duration,
        position: position,
        closeOnSwipe: false,
        fitToScreen: true,
        action: {
            text: "Close",
            onClick: (e, toastObject) => {
                toastObject.goAway(0);
            }
        }
    })
}

//  openQRCamera(files) {
//   console.log('==node====',files.target.files[0])
//    var reader = new FileReader();
//        var _self = this;
//        reader.onload = () => {
//          // node.value = "";
//          qrcode.callback = (res) => {
//            if(res instanceof Error) {
//              alert("No QR code found. Please make sure the QR code is within the camera's frame and try again.");
//            } else {
//              console.log('===',res)
//              _self.resQRUrl = res
//            }
//          };
//          qrcode.decode(reader.result);
//        };
//        reader.readAsDataURL(files.target.files[0]);
//  },